import styled from 'styled-components'

export const DetailSkeletonRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;
export const DetailFacts = styled.div`
    padding: 28px 0;
    border-top: 1px solid ${({ theme }) => theme.palette.colors.borderStrong};
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    @media (max-width: 720px) { grid-template-columns: repeat(2, 1fr); }
`;
export const DetailBlock = styled.div`
    min-height: 150px;
    padding: 28px 0;
    border-bottom: 1px solid ${({ theme }) => theme.palette.colors.borderSoft};
    display: flex;
    flex-direction: column;
    gap: 14px;
`;
